import { render, staticRenderFns } from "./AppSettingsModal.vue?vue&type=template&id=4f903b63&scoped=true&"
import script from "./AppSettingsModal.vue?vue&type=script&lang=js&"
export * from "./AppSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsModal.vue?vue&type=style&index=0&id=4f903b63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f903b63",
  null
  
)

export default component.exports